import register from '../../../../global/js/registry';
export default register('m-teaser-list-item', () => import(/* webpackMode: "lazy" */ './m-teaser-list-item.controller'));
